import { type AllCollection } from '$lib/types/Collections';
import { _ } from 'svelte-i18n';
import { get } from 'svelte/store';

/**
 * Creates a default "All" collection object that implements the Collection interface.
 * This special collection is used to represent all items, with a null ID.
 * Created only for the FE, this is not stored in the DB.
 */
export const getAllCollection = (hubId?: string) => {
	return {
		id: null,
		hub_id: hubId || '',
		name: get(_)('common.all'),
		tags: [],
		slug: '',
		index: 0,
		archived: false,
		min_role: 'member',
		asset_count: 0,
		tag_counts: [
			{
				name: '',
				count: 0,
				visible: false,
			},
		],
	} satisfies AllCollection;
};
